import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../services/utility-service';
import { ApiService } from '../../../services/api.service';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import { ArrayOfKeys } from '../../../model/ArrayOfKeys';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { Constants } from '../../../constants/ebtq-constants';
import { CurrencyPipe } from '@angular/common';
import {Title} from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'queryLoansResult',
  templateUrl: './query-loans-result.component.html',
  styleUrls: ['./query-loans-result.component.scss']
})
export class QueryLoansResultComponent implements OnInit, OnDestroy {
  private errorSub: Subscription;
  cols: any[];
  containsError = false;
  transactionWrapper: TransactionWrapper;
  errorMsg: string;
  showResult: any[];
  paymentPlan = [];
  productType = [];
  arrayOfkeys: any[];
  mainPage: string;
  loanResultKeys: any[];
  pageView: any[];
  selectedPageView: string[];
  exportFilename = 'LoanListing';
  title = 'List of Loans';

  constructor(private activeRouter: ActivatedRoute, private router: Router, private currencyPipe: CurrencyPipe,
     private apiService: ApiService, private utilService: UtilityService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    this.fetchRecords();
    this.pageView = [];
    this.pageView.push({label: 'Printable View', value: 'printView'});
    this.pageView.push({label: 'Download To Excel', value: 'downloadtoExcel'});
    this.selectedPageView = ['printView'];
  }

  /** Define the column header */
  ngOnInit() {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.paymentPlan = this.utilService.queryLoanPaymentPln;
    this.productType = this.utilService.productCode;

    this.cols = [
      { field: 'ServicerNum', header: 'Servicer Number' },
      { field: 'LoanNum', header: 'Loan Number' },
      { field: 'PaymentPlan', header: 'Payment Plan' },
      { field: 'ProductType', header: 'Product Type' },
      { field: 'LoanBalanceCurr', header: 'Loan Balance' },
      { field: 'NetPrncplLimitCurr', header: 'Net Princ Limit' },
      { field: 'NetLineofCreditCurr', header: 'Net LOC' }
    ];
    this.cdr.detectChanges();
  }

  public pageViewAction(event: any) {
    if (this.selectedPageView.toString() === 'downloadtoExcel') {
      event.exportCSV();
    }
    if (this.selectedPageView.toString() === 'printView')
    {
      const printDetailsMap = new Map();
      printDetailsMap.set('title', 'Loan List');
      printDetailsMap.set('columns', event.columns);
      printDetailsMap.set('data', this.showResult);

      this.utilService.printViewData(printDetailsMap);
      this.router.navigate(['print']);
    }
  }


  public showLoanDetails(data: any) {
    this.loanDetails(data.LoanNum);
  }
  fetchRecords(): void {
    let arrayOfkeys: ArrayOfKeys;
    let keys;
    this.activeRouter.queryParams.subscribe(params => {
      this.loanResultKeys = params.loanResult;
      if (this.loanResultKeys != null) {
        keys = this.loanResultKeys;
      }
      else {
        keys = JSON.parse(atob(params.query));
      }
      if (this.loanResultKeys != null) {
        keys = this.loanResultKeys;
      }
      this.arrayOfkeys = keys;
      this.mainPage = params.mainPage;
    });

    arrayOfkeys = new ArrayOfKeys();
    arrayOfkeys.keys = keys;
    this.transactionWrapper = new TransactionWrapper();
    this.transactionWrapper.queryServiceName = Constants.LOAN_QUERY_RESULT_LIST;
    this.transactionWrapper.parameters[0] = keys;
    //this.apiService.getTransmissionList(this.transactionWrapper).subscribe(
    this.apiService.executeQuery(this.transactionWrapper).subscribe(
      (data: any) => {
        this.showResult = [];
        const values = [];
        //Obj is List of keys
        const obj = Object.values(data.object);
        for (const [key, value] of Object.entries(obj)) {
          values[key] = value;
          if ((value as any).ProductType) {
            (value as any).ProductType = (this.productType.find(s => s.value === (value as any).ProductType)).label;
          }
          if ((value as any).PaymentPlan) {
            (value as any).PaymentPlan = (this.paymentPlan.find(s => s.value === (value as any).PaymentPlan.toString())).label;
          }
          if ((value as any).LoanBalanceCurr != null) {
            (value as any).LoanBalanceCurr = this.currencyPipe.transform(parseFloat((value as any).LoanBalanceCurr).toFixed(2), 'USD');

          }
          if ((value as any).NetPrncplLimitCurr != null) {
            (value as any).NetPrncplLimitCurr = this.currencyPipe.transform(parseFloat((value as any).NetPrncplLimitCurr).toFixed(2), 'USD');

          }
          if ((value as any).NetLineofCreditCurr != null) {
            (value as any).NetLineofCreditCurr = this.currencyPipe.transform(parseFloat((value as any).NetLineofCreditCurr).toFixed(2), 'USD');
          }
          this.showResult.push(value);
        }
        this.cdr.detectChanges();
      },

      error => {
        this.errorService.announceError(error);
      }
    );
    this.errorAnnouncement();
  }
  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }
  //Routing to get LoanDetail Page with LoanId as perameter.
  public loanDetails(inputLoanNumber: any) {
    this.loanResultKeys = this.arrayOfkeys;
    this.router.navigate(['queryLoansDetails'], {
      queryParams: { loanNumber: inputLoanNumber, query: this.arrayOfkeys, mainPage:this.mainPage, loanResult:this.loanResultKeys }
    });
  }
}
